define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StockNameDomain = void 0;
    class StockNameDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: StockNameDomain.Cattle, value: "Cattle" },
                    { key: StockNameDomain.Horses, value: "Horses" },
                    { key: StockNameDomain.Buffalo, value: "Buffalo" },
                    { key: StockNameDomain.Donkeys, value: "Donkeys" },
                    { key: StockNameDomain.Mules, value: "Mules" },
                    { key: StockNameDomain.Asses, value: "Asses" },
                    { key: StockNameDomain.Alpacas, value: "Alpacas" },
                    { key: StockNameDomain.Camels, value: "Camels" },
                    { key: StockNameDomain.Llamas, value: "Llamas" },
                    { key: StockNameDomain.Vicunas, value: "Vicunas" },
                    { key: StockNameDomain.Sheep, value: "Sheep" },
                    { key: StockNameDomain.Goats, value: "Goats" },
                    { key: StockNameDomain.Deer, value: "Deer" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[StockNameDomain.Cattle] = 0;
                this.KeyIndex[StockNameDomain.Horses] = 1;
                this.KeyIndex[StockNameDomain.Buffalo] = 2;
                this.KeyIndex[StockNameDomain.Donkeys] = 3;
                this.KeyIndex[StockNameDomain.Mules] = 4;
                this.KeyIndex[StockNameDomain.Asses] = 5;
                this.KeyIndex[StockNameDomain.Alpacas] = 6;
                this.KeyIndex[StockNameDomain.Camels] = 7;
                this.KeyIndex[StockNameDomain.Llamas] = 8;
                this.KeyIndex[StockNameDomain.Vicunas] = 9;
                this.KeyIndex[StockNameDomain.Sheep] = 10;
                this.KeyIndex[StockNameDomain.Goats] = 11;
                this.KeyIndex[StockNameDomain.Deer] = 12;
                this.ValueIndex = {};
                this.ValueIndex["Cattle"] = 0;
                this.ValueIndex["Horses"] = 1;
                this.ValueIndex["Buffalo"] = 2;
                this.ValueIndex["Donkeys"] = 3;
                this.ValueIndex["Mules"] = 4;
                this.ValueIndex["Asses"] = 5;
                this.ValueIndex["Alpacas"] = 6;
                this.ValueIndex["Camels"] = 7;
                this.ValueIndex["Llamas"] = 8;
                this.ValueIndex["Vicunas"] = 9;
                this.ValueIndex["Sheep"] = 10;
                this.ValueIndex["Goats"] = 11;
                this.ValueIndex["Deer"] = 12;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.StockNameDomain = StockNameDomain;
    Object.defineProperty(StockNameDomain, "Cattle", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Cattle"
    });
    Object.defineProperty(StockNameDomain, "Horses", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Horses"
    });
    Object.defineProperty(StockNameDomain, "Buffalo", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Buffalo"
    });
    Object.defineProperty(StockNameDomain, "Donkeys", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Donkeys"
    });
    Object.defineProperty(StockNameDomain, "Mules", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Mules"
    });
    Object.defineProperty(StockNameDomain, "Asses", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Asses"
    });
    Object.defineProperty(StockNameDomain, "Alpacas", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Alpacas"
    });
    Object.defineProperty(StockNameDomain, "Camels", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Camels"
    });
    Object.defineProperty(StockNameDomain, "Llamas", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Llamas"
    });
    Object.defineProperty(StockNameDomain, "Vicunas", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Vicunas"
    });
    Object.defineProperty(StockNameDomain, "Sheep", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Sheep"
    });
    Object.defineProperty(StockNameDomain, "Goats", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Goats"
    });
    Object.defineProperty(StockNameDomain, "Deer", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Deer"
    });
    Object.defineProperty(StockNameDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
